"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgClose = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M12 0C5.39 0 0 5.39 0 12s5.39 12 12 12 12-5.39 12-12S18.61 0 12 0zm4.688 15.281a1.02 1.02 0 010 1.406 1.033 1.033 0 01-.704.282c-.234 0-.515-.094-.703-.282L12 13.408l-3.281 3.28a1.034 1.034 0 01-.703.282c-.235 0-.516-.094-.704-.282a1.02 1.02 0 010-1.406L10.595 12 7.313 8.719a1.02 1.02 0 010-1.406 1.02 1.02 0 011.406 0L12 10.592l3.281-3.28a1.02 1.02 0 011.406 0 1.02 1.02 0 010 1.406L13.408 12l3.28 3.281z" })));
};
exports.default = SvgClose;
//# sourceMappingURL=Close.js.map